const topics = [
  { label: '#顶流塌房', heat: '986.5万', trend: 'up' },
  { label: '#演唱会假唱', heat: '823.2万', trend: 'up' },
  { label: '#影视换角风波', heat: '756.8万', trend: 'hot' },
  { label: '#明星小号曝光', heat: '689.4万', trend: 'up' },
  { label: '#综艺现场争执', heat: '612.7万', trend: 'steady' },
  { label: '#网红直播翻车', heat: '545.3万', trend: 'up' },
  { label: '#女星婚变疑云', heat: '478.9万', trend: 'hot' },
  { label: '#选秀黑幕录音', heat: '412.6万', trend: 'new' },
  { label: '#匿名圈内爆料', heat: '356.1万', trend: 'up' },
];

export default function TopicsSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return { icon: 'ri-arrow-up-line', color: 'text-primary-500' };
    if (trend === 'hot') return { icon: 'ri-fire-line', color: 'text-accent-500' };
    if (trend === 'new') return { icon: 'ri-flashlight-line', color: 'text-primary-500' };
    return { icon: 'ri-subtract-line', color: 'text-foreground-400' };
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            全网最热话题标签，看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, idx) => {
            const ti = trendIcon(topic.trend);
            return (
              <a
                key={idx}
                href="#carousel"
                className="flex items-center gap-3 bg-background-100 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex-1 min-w-0">
                  <span className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors truncate block">
                    {topic.label}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1 mt-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {topic.heat} 热度
                  </span>
                </div>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-200 ${ti.color}`}>
                  <i className={`${ti.icon} text-sm`}></i>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}